<template>
  <div>
    <!-- 頁腳 -->
    <div
      class="grey darken-4 white--text text-md-center text-body-2 py-3 px-4"
      :class="$vuetify.breakpoint.width > 959.98 ? 'd-flex' : ''"
    >
      <div class="mouse-pointer d-sm-flex py-2 py-sm-0" @click="GoAddress()">
        <div class="">{{ copyright }}</div>
        <div class="">{{ company }}</div>
        <div class="">{{ address }}</div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-sm-flex py-2 py-sm-0 mt-0 mt-sm-4 mt-md-0">
        <div class="pa-2 py-3 py-sm-0 ma-md-0 mx-md-2 py-2 py-sm-0">
          <a
            href="https://kingfong9595.blog/kf-training/"
            target="_blank"
            style="color: #ffffff; text-decoration: none"
          >
            {{ adComp }}</a
          >
        </div>
        <div class="pa-2 py-3 py-sm-0 ma-md-0 mx-md-2">
          <a
            href="https://kingfong9595.blog/contact-taro/"
            target="_blank"
            style="color: #ffffff; text-decoration: none"
          >
            {{ contect }}</a
          >
        </div>
        <div
          class="mouse-pointer pa-2 py-3 py-sm-0 ma-md-0 mx-md-2"
          @click="GoDisclaimer()"
        >
          {{ disclaimer }}
        </div>
        <div
          class="mouse-pointer pa-2 py-3 py-sm-0 ma-md-0 mx-md-2"
          @click="GoPrivacyPolicy()"
        >
          {{ privacyPolicy }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      copyright: "©2022 金豐企業管理顧問股份有限公司",
      mainCopmapnyName: "https://www.king-fong.com/",
      company: ". 小芋頭資訊工作室",
      companyUrl: "https://www.kf-9595.com",
      address: ". 高雄市左營區大順一路91號10樓之3",
      freeService: "免費服務專線電話",
      freeServiceNumber: "0800-06-9595(0800-您來-教我教我)",
      adComp: "顧問培訓及合作",
      contect: "聯絡我們",
      disclaimer: "免責聲明",
      privacyPolicy: "隱私權政策",
    };
  },
  methods: {
    // 免責聲明
    GoDisclaimer() {
      this.$router.push({ name: "Disclaimer" });
    },
    // 隱私權政策
    GoPrivacyPolicy() {
      this.$router.push({ name: "PrivacyPolicy" });
    },
    GoAddress() {
      let newWin = window.open();
      newWin.location.replace(this.companyUrl);
    },
  },
};
</script>

<style>
.footer-h {
  height: 168px;
}
</style>
